module.exports = __webpack_public_path__ + "static/media/European-Union.76bd1c91.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/European-Union.png
// module id = 1747
// module chunks = 1